import { render, staticRenderFns } from "./addStorage.vue?vue&type=template&id=7afbefe9&scoped=true"
import script from "./addStorage.vue?vue&type=script&lang=js"
export * from "./addStorage.vue?vue&type=script&lang=js"
import style0 from "./addStorage.vue?vue&type=style&index=0&id=7afbefe9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afbefe9",
  null
  
)

export default component.exports